import { _ as _classCallCheck, a as _createClass } from '../../dist/createClass-38c45ab6.esm.js';
import { _ as _inherits, a as _createSuper, b as _assertThisInitialized, c as _wrapNativeSuper } from '../../dist/wrapNativeSuper-aecc63dc.esm.js';
import { _ as _defineProperty } from '../../dist/defineProperty-6a97efcd.esm.js';
import 'core-js/modules/es.number.is-integer.js';
import 'core-js/modules/es.number.constructor.js';

/**
 * Error subclass for http errors.
 */
var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);
  var _super = _createSuper(HttpError);
  function HttpError( /** Number error code */
  code, /** Human-readable string */
  message, /** Low-level error */
  internal, /** Other useful information about error */
  data) {
    var _this;
    _classCallCheck(this, HttpError);
    if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
    if (!message || typeof message !== 'string') throw new Error('"message" must be a nonempty string.');
    _this = _super.call(this, message);
    _defineProperty(_assertThisInitialized(_this), "code", void 0);
    _defineProperty(_assertThisInitialized(_this), "data", void 0);
    _defineProperty(_assertThisInitialized(_this), "internal", void 0);
    _this.code = code;
    _this.data = data;
    _this.internal = internal;
    return _this;
  }
  return _createClass(HttpError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { HttpError };
